import React from 'react';
import useTimeLaunchState from '../../hooks/useTimeLaunchState';
import { useFooterSafeBottom } from '../../hooks/useFooterSafeBottom';
import type { ClockedPhotoTarget } from '@/data/clockedJobPhotos';
import BarcodeScannerFab from './BarcodeScannerFab';
const Scanner = React.lazy(() => import('./HomeBarcodeScannerWidget'));
const PhotoDialog = React.lazy(() => import('../photos/ClockedJobPhotoDialog'));

/** The home action follows the actual clock entry, independently of inventory rights. */
export default function HomeJobCaptureAction({ canUseInventoryTools }: { canUseInventoryTools: boolean }) {
  const { data, authorizationKey } = useTimeLaunchState();
  const [scannerOpen, setScannerOpen] = React.useState(false);
  const [target, setTarget] = React.useState<ClockedPhotoTarget | null>(null);
  const bottom = useFooterSafeBottom();
  const active = data?.active;
  const camera = Boolean(active?.photo_enabled && !active.clock_out);
  React.useEffect(() => { if (camera) setScannerOpen(false); }, [camera]);
  React.useEffect(() => { setTarget(null); setScannerOpen(false); }, [authorizationKey]);
  return <>
    {camera && active ? <button type="button" className="home-barcode-widget__fab"
      style={{ '--home-barcode-fab-bottom': `${bottom}px` } as React.CSSProperties}
      aria-label={`Add photos to ${active.job_code}`} title={`Job photos: ${active.job_code}`} onClick={() => setTarget({
        entry_id: active.entry_id, job_kind: active.job_kind, job_id: active.job_id, job_code: active.job_code, job_name: active.job_name,
      })}>
      <span className="home-barcode-widget__fab-icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 7h4l2-3h4l2 3h4v13H4z" /><circle cx="12" cy="13" r="4" /></svg></span>
    </button> : canUseInventoryTools ? scannerOpen ? <React.Suspense fallback={<BarcodeScannerFab onClick={() => undefined} disabled />}>
      <Scanner initialOpen />
    </React.Suspense> : <BarcodeScannerFab onClick={() => setScannerOpen(true)} /> : null}
    {target ? <React.Suspense fallback={<p role="status" className="sr-only">Loading job photos...</p>}>
      <PhotoDialog key={authorizationKey} target={target} current={active} onClose={() => setTarget(null)} />
    </React.Suspense> : null}
  </>;
}
